<style lang="scss">
$day-border-color: #d6d9e4;
$grey-bg: #f0f1f4;

.vc-container {
  border: none;

  .vc-header {
    height: 50px;
    margin-bottom: 15px;

    .vc-title {
      font-size: 18px;
      color: var(--theme-color);
      font-weight: 600;
      letter-spacing: 2.1px;
      text-transform: uppercase;
    }
  }

  .vc-arrows-container {
    .vc-cursor-pointer {
      background-color: var(--theme-color) !important;
      color: white !important;
      width: 30px;
      height: 30px;
      position: relative;
      top: 5px;
      border-radius: 15px;
      box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.2),
        0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14);
    }
  }

  // First row: Days
  .vc-weeks {
    .vc-weekday {
      color: var(--theme-color) !important;
      font-size: 14px;
      font-weight: normal;
    }

    div:not(.vc-grid-cell-row-1).vc-grid-cell {
      border: 1px $day-border-color solid;

      .in-prev-month,
      .in-next-month {
        background-color: $grey-bg;
      }
    }

    .vc-day {
      .vc-h-full {
        width: 100%;
      }

      .vc-highlight {
        background-color: var(--theme-color) !important;
        width: 100%;
        height: 100%;
        border: none;
        border-radius: 0;
      }

      .vc-day-content:focus,
      .vc-day-content:hover {
        background-color: transparent;
        width: 100%;
        border: 4px $day-border-color solid;
        border-radius: 0;
      }
    }
  }
}

.agenda-options-selector {
  position: absolute;
  left: 30px;
  top: 9px;
  z-index: 10;
  width: 40%;
}

.vuecal__menu {
  height: 53px;

  .vuecal__view-btn {
    display: none;
  }
}

.vuecal__event.weekly-appointment {
  font-size: 13px;
  font-weight: 500;
  color: var(--theme-text-color);
  padding: 5px;
  border: 1px var(--theme-grey) solid;
  background-color: var(--theme-grey-bg);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column nowrap;
  position: relative;

  &__cancelled {
    color: white;
    background-color: var(--teme)
  }

  &__arrived {
    background-color: var(--theme-color-arrived);
    color: white;
  }

  &__attended {
    background-color: var(--theme-color-attended);
    color: white;
  }

  &__cancel {
    background-color: var(--theme-color-canceled);
    color: white;
  }

  &__absent {
    background-color: var(--theme-color-absent);
    color: white;
  }

  &__treated {
    background-color: var(--theme-color-treated);
    color: white;
  }

  &__gone {
    background-color: var(--theme-color-gone);
    opacity: 0.5;
  }

  &__revision {
    background-color: var(--theme-color-revision);
    color: white;
  }

  &__urgent {
    background-color: var(--theme-color-urgent);
    color: white;
  }

  &__insurance {
    background-color: var(--theme-color-insurance);
    color: white;
  }

  &__marked {
    background-color: var(--theme-color-marked);
    color: white;
  }

  .appointment {
    &__photo {
      img {
        width: 20px;
        height: 20px;
        margin-bottom: 2px;
        border-radius: 10px;
        object-fit: cover;
        text-align: center;
      }
    }

    &__title {
      font-weight: bold;
    }

    &__box {
      font-size: 12px;
    }

    &__notes {
      font-size: 400;
      font-size: 12px;
      line-height: 1.1;
      padding: 3px;
    }

    &__notes-icon {
      position: absolute;
      top: 0;
      right: 0;
      padding: 5px;
    }
  }
}

.vuecal__no-event {
  display: none;
}

.vc-grid-container.grid {
  grid-template-columns: repeat(1, minmax(100%, 1fr)) !important;
}

.agenda-daily-core .vuecal {
  max-height: calc(100vh - 150px);
}
</style>

<template>
  <div class="container-fluid" @mousemove="resetIdle" @keypress="resetIdle" @mousedown="resetIdle" @mouseup="resetIdle">
    <agenda-show-appointment ref="appdialog" :clinics="clinics" mode="boxes"
      @submit="onAppSubmit"></agenda-show-appointment>
    <div class="row mx-3">
      <div id="calendar-column" class="col-xl-2 col-lg-12 order-xl-first order-lg-last">
        <!-- Calendar widget -->
        <vc-calendar ref="vcalendar" :disabled-dates="{ weekdays: [1, 7] }" :first-day-of-week="2"
          :attributes="cal_attrs" :is-expanded="true" @dayclick="daySelected" @update:fromPage="calendarPageUpdated">
        </vc-calendar>
        <!-- Month / Year Selector -->
        <div class="form-group row no-gutters">
          <div class="col">
            <div class="mx-1">
              <select v-model.number="show_month" id="month_selector" class="form-control custom-select size-s">
                <option value="1">Enero</option>
                <option value="2">Febreo</option>
                <option value="3">Marzo</option>
                <option value="4">Abril</option>
                <option value="5">Mayo</option>
                <option value="6">Junio</option>
                <option value="7">Julio</option>
                <option value="8">Agosto</option>
                <option value="9">Septiembre</option>
                <option value="10">Octubre</option>
                <option value="11">Noviembre</option>
                <option value="12">Diciembre</option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="mx-1">
              <select v-model.number="show_year" id="year_selector" class="form-control custom-select size-s">
                <option v-for="(n, index) in 10" :key="index" :value="n + from_year">
                  {{ n + from_year }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <!-- Attended Customer List -->
        <agenda-attended-customers @appointmentChecked="appointmentChecked" @appointmentGone="appointmentGone"
          :appointments="arrived_appointments"></agenda-attended-customers>
      </div>
      <!-- Appointments view -->
      <div class="col-xl-10 col-lg-12 order-xl-last order-lg-first px-xl-2 px-lg-0">
        <!-- Doctor Filters -->
        <div class="agenda-options-selector">
          <div class="d-flex align-items-center">
            <span v-if="weekly_agenda_enabled" class="mx-2">Ver:</span>
            <select v-if="weekly_agenda_enabled" id="select_agenda" v-model="agenda_mode"
              class="custom-select wabident-xsmall">
              <option value="daily">Agenda Diaria</option>
              <option value="weekly">Agenda Semanal</option>
            </select>
            <span v-if="weekly_agenda_enabled" class="mx-2">de:</span>
            <span v-else class="mx-2">Filtrar:</span>
            <select id="select_doctor" v-model="doctor_id" class="custom-select wabident-xsmall"
              :disabled="lock_doctor">
              <option :value="null">Tod@s</option>
              <option v-for="(doctor, index) in doctors" :key="index" :value="doctor.doctor.id">
                {{ doctor.name }}
              </option>
            </select>
            <button v-if="doctor_id && agenda_mode == 'daily'" @click="printDoctorAgenda" type="button"
              class="btn btn-wabident-round mx-3"><i class="fa fa-print"></i></button>
          </div>
        </div>

        <!-- Main Appointments View -->
        <div v-if="agenda_mode == 'weekly'">
          <vue-cal v-if="doctor_id" :disable-views="['years', 'year', 'day', 'month']" :time-from="calendar_time_from"
            :time-to="calendar_time_to" :snap-to-time="calendar_time_step" :time-step="30"
            :events="calendar_weekly_events" :hide-weekdays="calendar_hide_weekdays" :on-event-click="onEventClick"
            @cell-click="onEmptyCellClick" locale="es">
            <template #event="{ event }">
              <div v-if="event.appointment.customer_id" class="appointment__photo">
                <img loading="lazy" :style="{ transform: `rotate(${event.appointment.customer.photo_rotate}deg)` }"
                  :src="`/customer/${event.appointment.customer_id}/thumbnail`" />
              </div>
              <div class="appointment__title">{{ event.title }}</div>
              <div class="appointment__box">{{ box_names[event.appointment.box_id] }}</div>
              <div v-if="event.appointment.notes && event.appointment.notes != ''" class="appointment__notes-icon"
                :title="event.appointment.notes" v-b-tooltip.hover>
                <i class="fa fa-comments"></i>
              </div>
            </template>
          </vue-cal>
          <div v-else class="agenda-choose-doctor text-center py-4">
            <h3 class="my-5">
              Seleccione Doctor/a para mostrar su Agenda Semanal
            </h3>
          </div>
        </div>
        <agenda-appointments v-else ref="appointments" @customerEnters="customerEnters"
          @appSelected="appointmentSelected" :date="selected_date" :appointments="appointments"
          :availability="availability" :clinic="clinic" :selected_doctor="doctor_id" :default_num_boxes="num_boxes"
          :mode="is_core ? 'doctors' : 'boxes'" :loading="false">
        </agenda-appointments>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["clinic_id"],
  data: function () {
    return {
      selected_date: new Date(),
      doctor_id: null,
      appointments: [],
      weekly_appointments: [],
      availability: [],
      show_month: new Date().getMonth() + 1,
      show_year: new Date().getFullYear(),
      from_year: new Date().getFullYear() - 5,
      idle_time: 0,
      agenda_mode: 'daily',
    };
  },
  watch: {
    agenda_mode() {
      this.loadAppointments();
    },
    show_month() {
      this.updateCalendarFromSelectors();
    },
    show_year() {
      this.updateCalendarFromSelectors();
    },
    doctor_id() {
      this.loadAppointments();
    },
    selected_date(val) {
      if (val) {
        window.history.pushState({}, 'Agenda', '/agenda?date=' + moment(val).format('YYYY-DD-MM'));
      }
    }
  },
  computed: {
    lock_doctor() {
      return this.user_capabilities && this.user_capabilities.agenda_unique;
    },
    weekly_agenda_enabled() {
      if (!this.clinic) return false;
      return this.clinic.config.enable_weekly_agenda || false;
    },
    box_names() {
      let ret = {};

      if (this.clinic) {
        this.clinic.boxes.forEach((box) => {
          ret[box.id] = box.name;
        });
      }
      return ret;
    },
    calendar_weekly_events() {
      let ret = [];

      this.weekly_appointments.forEach((box) => {
        box.appointments.forEach((app) => {
          ret.push({
            start: moment(app.date_from).toDate(),
            end: moment(app.date_to).toDate(),
            title: app.customer ? app.customer.name : 'NOTA',
            class: 'weekly-appointment weekly-appointment__' + app.status,
            appointment: app,
          });
        })
      });

      return ret;
    },
    calendar_daily_events() {
      let ret = [];

      this.appointments.forEach((box) => {
        box.appointments.forEach((app) => {
          ret.push({
            start: moment(app.date_from).toDate(),
            end: moment(app.date_to).toDate(),
            title: app.customer ? app.customer.name : 'NOTA',
            class: 'daily-appointment daily_appointment__' + app.status,
            appointment: app,
            split: box.id,
          });
        })
      });

      return ret;
    },
    calendar_split_days() {
      let ret = [];

      this.appointments.forEach((box) => {
        ret.push({
          id: box.id,
          class: `box-${box.id}`,
          label: box.name,
        });
      });

      return ret;
    },
    calendar_hide_weekdays() {
      if (!this.clinic) return [6, 7];
      let ret = [];
      for (let i = 0; i < 7; i++) {
        if (!this.clinic.schedule.daily_timeslots[i].checked) {
          ret.push(i + 1);
        }
      }
      return ret;
    },
    calendar_time_from() {
      if (!this.clinic) return 7 * 60;
      let ret = Number.MAX_SAFE_INTEGER;

      this.clinic.schedule.daily_timeslots.forEach((day) => {
        if (day.checked) {
          day.morning.start.forEach((slot) => {
            let m = slot.split(":");
            let hours = Number(m[0]);
            let minutes = Number(m[1]);
            let v = hours * 60 + minutes;
            ret = Math.min(ret, v);
          });

          day.afternoon.start.forEach((slot) => {
            let m = slot.split(":");
            let hours = Number(m[0]);
            let minutes = Number(m[1]);
            let v = hours * 60 + minutes;
            ret = Math.min(ret, v);
          });
        }
      });

      return ret || 7 * 60;
    },
    calendar_time_to() {
      if (!this.clinic) return 21 * 60;
      let ret = 0;

      this.clinic.schedule.daily_timeslots.forEach((day) => {
        if (day.checked) {
          day.morning.end.forEach((slot) => {
            let m = slot.split(":");
            let hours = Number(m[0]);
            let minutes = Number(m[1]);
            let v = hours * 60 + minutes;
            ret = Math.max(ret, v);
          });

          day.afternoon.end.forEach((slot) => {
            let m = slot.split(":");
            let hours = Number(m[0]);
            let minutes = Number(m[1]);
            let v = hours * 60 + minutes;
            ret = Math.max(ret, v);
          });
        }
      });

      return ret || 21 * 60;
    },
    calendar_time_step() {
      return this.calendar_snap_to;
    },
    calendar_snap_to() {
      if (!this.clinic) return 0;
      return Number(this.clinic.schedule.slot_minutes);
    },
    available_dates() {
      let ret = [];

      this.availability.forEach((av) => {
        if (av.is_available) {
          ret.push(moment(av.date_from).toDate());
        }
      });

      return ret;
    },
    unavailable_dates() {
      let ret = [];

      this.availability.forEach((av) => {
        if (!av.is_available) {
          ret.push(moment(av.date_from).toDate());
        }
      });

      return ret;
    },
    cal_attrs() {
      return [
        {
          dates: new Date(),
          highlight: true,
          key: "today",
        },
        {
          dot: 'green',
          dates: this.available_dates,
        },
        {
          dot: 'red',
          dates: this.unavailable_dates,
        },
      ];
    },
    doctors() {
      if (!this.clinic) return [];
      return this.clinic.doctors.filter((d) => {
        if (d.doctor != null) {
          return true;
        } else {
          console.log('-- User doctor is null ' + d.id);
          return;
        };
      });
    },
    enable_doctor_availability() {
      if (!this.clinic) return false;
      if (!this.clinic.config) return false;
      return this.clinic.config.enable_doctor_availability || false;
    },
    num_boxes() {
      if (!this.clinic) return 3;
      if (!this.clinic.config) return 3;
      return Number(this.clinic.config.agenda_num_boxes) || 3;
    },
    clinics() {
      if (!this.clinic) return [];
      return this.clinic.clinic_names;
    },
    arrived_appointments() {
      if (!this.appointments || this.appointments.lenght == 0) return [];

      let ret = [];

      this.appointments.forEach((box) => {
        box.appointments.forEach((appointment) => {
          if (appointment.arrival_time && appointment.status != "gone") {
            appointment.box = box.name;
            ret.push(appointment);
          }
        });
      });

      ret.sort((a, b) => {
        return a.arrival_time > b.arrival_time;
      });

      return ret;
    },
    ...mapGetters(["clinic", "msgwindow", "is_core", "user_capabilities"]),
  },
  methods: {
    onCalViewchange(e) {
      if (e.view == 'day') {
        let d = moment(e.startDate).format('YYYY-MM-DD');
        this.daySelected({
          id: d,
        });
      }
    },
    onEventClick(event, e) {
      if (event.appointment) {
        this.$refs.appdialog.showEdit(
          event.appointment,
          this.selected_date,
          null,
          null
        );
      }
      e.stopPropagation();
    },
    onEmptyCellClick(date) {
      if (!this.user_capabilities.agenda_restricted) {
        let m = moment(date);
        this.$refs.appdialog.show(date, {
          hour: m.hour(),
          minute: m.minutes()
        }, null, this.doctor_id);
      }
    },
    updateCalendarFromSelectors() {
      if (this.$refs.vcalendar) {
        this.$refs.vcalendar.showPageRange({
          month: this.show_month,
          year: this.show_year,
        });
      }
    },
    daySelected(day) {
      let new_date = new Date(day.id);
      this.selected_date = new_date;
      this.loadAppointments();
    },
    loadAppointments() {
      switch (this.agenda_mode) {
        case 'weekly':
          this.loadWeeklyAppointments();
          break;
        case 'daily_core':
          this.loadDailyAppointments();
          break;
        default:
          this.loadDailyAppointments();
      }
    },
    loadWeeklyAppointments() {
      let params = {
        params: {
          date: this.selected_date,
          clinic_id: this.clinic_id,
          doctor_id: this.doctor_id,
        },
      };

      axios
        .get(`/clinic/${this.clinic_id}/weekly`, params)
        .then((response) => {
          let data = response.data;
          if (data.appointments) {
            this.weekly_appointments = data.appointments;
          }
          if (data.availability) {
            this.availability = data.availability;
          } else {
            this.availability = [];
          }

          if (this.lock_doctor) {
            this.lockDoctorID();
          }
        })
        .catch((error) => {
          console.log(error);
        });

    },
    loadDailyAppointments() {
      let params = {
        params: {
          date: this.selected_date,
          clinic_id: this.clinic_id,
          doctor_id: this.doctor_id,
        },
      };
      axios
        .get(`/clinic/${this.clinic_id}/appointments`, params)
        .then((response) => {
          let data = response.data;
          if (data.appointments) {
            this.appointments = data.appointments;
          }
          if (data.availability) {
            this.availability = data.availability;
          } else {
            this.availability = [];
          }

          if (this.lock_doctor) {
            this.lockDoctorID();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    lockDoctorID() {
      if (this.clinic.doctor_id) {
        this.doctor_id = this.clinic.doctor_id;
      }
    },
    onAppSubmit() {
      this.loadAppointments();
    },
    customerEnters(appointment) {
      if (appointment && appointment.customer) {
        axios
          .post(
            `/clinic/${this.clinic.id}/appointments/${appointment.id}/presented`)
          .then((response) => {
            this.msgwindow.success("Paciente se presentó");
          })
          .catch((error) => {
            console.log("[ERR] appointmentChecked ", error);
          })
          .then(() => {
            this.onAppSubmit();
          });
      }
    },
    appointmentSelected(appointment, timeslot, box) {
      if (appointment) {
        this.$refs.appdialog.showEdit(
          appointment,
          this.selected_date,
          timeslot,
          box
        );
      } else if (!this.user_capabilities.agenda_restricted) {
        if (this.is_core) {
          if (box.doctor) {
            if (box.doctor.box_id) {
              let b = { id: box.doctor.box_id };
              this.$refs.appdialog.show(this.selected_date, timeslot, b, box.doctor.id);
            } else {
              this.$refs.appdialog.show(this.selected_date, timeslot, null, box.doctor.id);
            }
          } else {
            this.$refs.appdialog.show(this.selected_date, timeslot, null, null);
          }
        } else {
          this.$refs.appdialog.show(this.selected_date, timeslot, box, this.doctor_id);
        }
      }
    },
    appointmentChecked(checked, appointment) {
      if (appointment) {
        axios
          .post(
            `/clinic/${this.clinic.id}/appointments/${appointment.id}/check_in`,
            {
              checkin: checked,
            }
          )
          .then((response) => {
            if (checked) {
              this.msgwindow.success("Paciente atendido");
            } else {
              this.msgwindow.success("Paciente esperando ...");
            }
          })
          .catch((error) => {
            console.log("[ERR] appointmentChecked ", error);
          })
          .then(() => {
            this.onAppSubmit();
          });
      }
    },
    appointmentGone(appointment) {
      if (appointment) {
        axios
          .post(`/clinic/${this.clinic.id}/appointments/${appointment.id}/gone`)
          .then((response) => {
            this.msgwindow.success("Salida realizada");
          })
          .catch((error) => {
            console.log("[ERR] appointmentGone ", error);
          })
          .then(() => {
            this.onAppSubmit();
          });
      }
    },
    calendarPageUpdated(page) {
      this.show_month = page.month;
      this.show_year = page.year;
    },
    loadClinicData() {
      if (!this.clinic) {
        axios
          .get("/agenda/clinic_info", {
            params: {
              clinic_id: this.clinic_id,
            },
          })
          .then((response) => {
            let data = response.data;
            if (data.error) {
              console.log("[ERR] loadClinicData:", data.error);
            } else {
              this.setClinic(data);
              this.loadAppointments();
            }
          })
          .catch((error) => {
            console.log("[ERR] loadClinicData:", error);
          });
      }
    },
    resetIdle() {
      this.idle_time = 0;
    },
    printDoctorAgenda() {
      let params = new URLSearchParams({
        'date': moment(this.selected_date).format('YYYY-MM-DD'),
      });

      window.open(`/clinic/${this.clinic_id}/doctor_agenda/${this.doctor_id}?` + params.toString());
    },
    ...mapMutations(["setClinic"]),
  },
  mounted() {
    this.loadClinicData();
    setInterval(() => {
      this.idle_time += 1;
      if (this.idle_time >= 10) {
        this.loadAppointments();
        this.idle_time = 0;
      }
    }, 30 * 1000);
  },
};
</script>
